<div *ngIf="!formSubmitted; else thankYou">
    <div class="section">
        <h1 class="title">Your feedback</h1>
        <p>Please use the form below to provide feedback on the Screen for EPI in CP tool. It will take less than a
            minute to complete.</p>
    </div>
    <div class="form-header">
        <div class="horizontal-block">
            <h3 *ngIf="formStep === 1">About you</h3>
            <h3 *ngIf="formStep === 2">About the screening tool</h3>
            <h3 *ngIf="formStep === 3">About this website</h3>
            <h5>Step {{formStep}} <span>(of 3)</span></h5>
            <div class="progress-bar" #progressBar></div>
        </div>
    </div>
    <div class="form">
        <!-- HCP Check -->
        <form *ngIf="form" [formGroup]="form" (ngSubmit)="submitForm()">
            <div class="step1" *ngIf="formStep === 1" formGroupName="step1">
                <!-- Step 1 -->
                <div *ngIf="!verifiedHcp" class="form__item hcp-feedback">
                    <p class="form__copy">What is your specialty?</p>
                    <div class="select">
                        <app-custom-select [options]="specialtyOptions"
                            (setSelectedAnswer)="getSelectedAnswer($event)"></app-custom-select>
                    </div>
                    <input *ngIf="hcpSpecialty.value === 'Other'" type="text" class="custom-input"
                        placeholder="Please enter your specialty" formControlName="otherSpecialty">
                    <div class="horizontal-block">
                    </div>
                </div>
                <!-- How many patients with CP do you see in clinic in a month? -->
                <div class="form__item">
                    <p class="form__copy">How many patients with CP do you see in clinic in a month?</p>
                    <p class="form__sub-copy">Please select 1 answer.</p>
                    <label class="input-text" for="patientCount1">
                        <input type="radio" value="<5" formControlName="howManyPatients" id="patientCount1">< 5 patients 
                    </label>
                    
                    <label class="input-text" for="patientCount2"> 
                        <input type="radio" value="5-10" formControlName="howManyPatients" id="patientCount2">5 to 10 patients 
                    </label>
                    
                    <label class="input-text" for="patientCount3"> 
                        <input type="radio" value="10-20" formControlName="howManyPatients" id="patientCount3">10 to 20 patients 
                    </label>
                    
                    <label class="input-text" for="patientCount4"> 
                        <input type="radio" value=">20" formControlName="howManyPatients" id="patientCount4">> 20 patients 
                    </label>
                </div>
                <!-- Do you currently diagnose and/or treat EPI? -->
                <div class="form__item">
                    <p class="form__copy">Do you currently diagnose and/or treat EPI?</p>
                    <p class="form__sub-copy">Please select 1 answer.</p>
                       
                    <label class="input-text" for="diagnoseTreatYes"> 
                        <input type="radio" value="yes" formControlName="diagnoseTreat" id="diagnoseTreatYes">Yes 
                    </label>
                    
                    <label class="input-text" for="diagnoseTreatNo"> 
                        <input type="radio" value="no" formControlName="diagnoseTreat" id="diagnoseTreatNo">No 
                    </label>
                </div>
            </div>
            <!-- Step 2 -->
            <div class="step2" *ngIf="formStep === 2" formGroupName="step2">
                <!-- If you know the EPI status of your patient, does it align with the Screen for EPI in CP prediction? -->
                <div class="form__item">
                    <p class="form__copy">If you know the EPI status of your patient, does it align with the Screen for
                        EPI in CP prediction?</p>
                    <p class="form__sub-copy">Please select 1 answer.</p>
                        
                        <label class="input-text" for="statusAlignment1"> 
                            <input type="radio" value="yes" formControlName="statusAlignment" id="statusAlignment1">Yes 
                        </label>
                        
                        <label class="input-text" for="statusAlignment2"> 
                            <input type="radio" value="no" formControlName="statusAlignment" id="statusAlignment2">No 
                        </label>
                        
                        <label class="input-text" for="statusAlignment3"> 
                            <input type="radio" value="not applicable" formControlName="statusAlignment" id="statusAlignment3">Not applicable 
                        </label>
                </div>
                <!-- For a "more likely has EPI" prediction what is your next step for your patient? -->
                <div class="form__item">
                    <p class="form__copy">For a "more likely has EPI" prediction what is your next step for your
                        patient?</p>
                    <p class="form__sub-copy">Please select at least 1 answer.</p>
                    <label class="input-text" for="nextSteps1">
                        <input #scheduleAppointment type="checkbox" value="schedule an appointment"
                            [checked]="scheduleAppointment.value | isInArray: nextSteps.value"
                            (change)="updateNextSteps($event)" id="nextSteps1">
                        Schedule an appointment</label>
                    <label class="input-text" for="nextSteps2">
                        <input #orderPancreasImaging type="checkbox" value="order pancreas imaging"
                            [checked]="orderPancreasImaging.value | isInArray: nextSteps.value"
                            (change)="updateNextSteps($event)" id="nextSteps2">
                        Order pancreas imaging</label>
                    <label class="input-text" for="nextSteps3">
                        <input #orderStoolTest type="checkbox" value="order fecal elastase-1 stool test"
                            [checked]="orderStoolTest.value | isInArray: nextSteps.value"
                            (change)="updateNextSteps($event)" id="nextSteps3">
                        Order fecal elastase-1 stool test</label>
                    <label class="input-text" for="nextSteps4">
                        <input #orderSerumTests type="checkbox" value="order serum laboratory test(s)"
                            [checked]="orderSerumTests.value | isInArray: nextSteps.value"
                            (change)="updateNextSteps($event)" id="nextSteps4">
                        Order serum laboratory test(s)</label>
                    <label class="input-text" for="nextSteps5">
                        <input #pancreaticEnzymeTherapy type="checkbox"
                            value="initiate pancreatic enzyme replacement therapy"
                            [checked]="pancreaticEnzymeTherapy.value | isInArray: nextSteps.value"
                            (change)="updateNextSteps($event)" id="nextSteps5">
                        Initiate pancreatic enzyme replacement therapy</label>
                    <label class="input-text" for="nextSteps6">
                        <input #none type="checkbox" value="none of the above"
                            [checked]="none.value | isInArray: nextSteps.value" (change)="updateNextSteps($event)"
                            id="nextSteps6">
                        None of the above</label>
                </div>
                <!-- Did the Screen for EPI in CP tool meet your expectations? -->
                <div class="form__item">
                    <p class="form__copy">Did the Screen for EPI in CP tool meet your expectations?</p>
                    <p class="form__sub-copy">Please select 1 answer.</p>
                    <label class="input-text" for="expectations1">
                        <input type="radio" value="met expectations" formControlName="expectations"
                            id="expectations1">Met my expectations
                    </label>
                    <label class="input-text" for="expectations2">
                        <input type="radio" value="neutral" formControlName="expectations" id="expectations2">Neutral
                    </label>
                    <label class="input-text" for="expectations3">
                        <input type="radio" value="did not" formControlName="expectations" id="expectations3">Did not
                        meet my expectations
                    </label>
                </div>
                <!-- Would you recommend the use of the Screen for EPI in CP tool to other clinicians? -->
                <div class="form__item">
                    <p class="form__copy">Would you recommend the use of the Screen for EPI in CP tool to other
                        clinicians?</p>
                    <p class="form__sub-copy">Please select 1 answer.</p>
                    <label class="input-text" for="recommend1">
                        <input type="radio" value="yes" formControlName="recommend" id="recommend1">Yes
                    </label>
                    <label class="input-text" for="recommend2">
                        <input type="radio" value="no" formControlName="recommend" id="recommend2">No
                    </label>
                    <label class="input-text" for="recommend3">
                        <input type="radio" value="undecided" formControlName="recommend" id="recommend3">Undecided
                    </label>
                </div>
            </div>
            <!-- Step 3 -->
            <div class="step3" *ngIf="formStep === 3" formGroupName="step3">
                <!-- Did you find this website to be intuitive and easy to navigate? -->
                <div class="form__item">
                    <p class="form__copy">Did you find this website to be intuitive and easy to navigate?</p>
                    <p class="form__sub-copy">Please select 1 answer.</p>
                    <label class="input-text" for="intuitive1">
                        <input type="radio" value="yes" formControlName="intuitiveEasy" id="intuitive1">Yes
                    </label>
                    <label class="input-text" for="intuitive2">
                        <input type="radio" value="neutral" formControlName="intuitiveEasy" id="intuitive2">Neutral
                    </label>

                    <label class="input-text" for="intuitive3">
                        <input type="radio" value="no" formControlName="intuitiveEasy" id="intuitive3">No
                    </label>
                </div>
                <!-- Is the information presented in this website clear and accurate? -->
                <div class="form__item">
                    <p class="form__copy">Is the information presented in this website clear and accurate?</p>
                    <p class="form__sub-copy">Please select 1 answer.</p>

                    <label class="input-text" for="clearAccurate1">
                        <input type="radio" value="yes" formControlName="clearAccurate" id="clearAccurate1">Yes
                    </label>

                    <label class="input-text" for="clearAccurate2">
                        <input type="radio" value="neutral" formControlName="clearAccurate" id="clearAccurate2">Neutral
                    </label>

                    <label class="input-text" for="clearAccurate3">
                        <input type="radio" value="no" formControlName="clearAccurate" id="clearAccurate3">No
                    </label>
                </div>
                <!-- In terms of scientific content, was there… -->
                <div class="form__item">
                    <p class="form__copy">In terms of scientific content, was there…</p>
                    <p class="form__sub-copy">Please select 1 answer.</p>

                    <label class="input-text" for="scientificContent1">
                        <input type="radio" value="not enough detail" formControlName="scientificContent"
                            id="scientificContent1">Not enough detail
                    </label>

                    <label class="input-text" for="scientificContent2">
                        <input type="radio" value="the correct level of detail" formControlName="scientificContent"
                            id="scientificContent2">The correct level of detail
                    </label>

                    <label class="input-text" for="scientificContent3">
                        <input type="radio" value="too much detail" formControlName="scientificContent"
                            id="scientificContent3">Too much detail
                    </label>
                </div>
                <!-- How would you rate the educational value of this website? -->
                <div class="form__item">
                    <p class="form__copy">How would you rate the educational value of this website?</p>
                    <p class="form__sub-copy">Please select 1 answer.</p>
                    <label class="input-text" for="educationalValue1">
                        <input type="radio" value="high" formControlName="educationalValue" id="educationalValue1">High
                    </label>
                    <label class="input-text" for="educationalValue2">
                        <input type="radio" value="medium" formControlName="educationalValue" id="educationalValue2">
                        Medium
                    </label>

                    <label class="input-text" for="educationalValue3">
                        <input type="radio" value="low" formControlName="educationalValue" id="educationalValue3"> Low
                    </label>
                </div>
            </div>
            <div class="form__footer">
                <div class="feedback-button">
                    <app-button *ngIf="formStep !== 3; else submit" text="Continue"
                        [disableButton]="currentStep.invalid"
                        [variation]="currentStep.invalid ? 'button--disabled' : ''"
                        (btnClick)="continue()"></app-button>
                </div>
                <ng-template #submit>
                    <div class="captcha desktop-only">
                        <re-captcha (resolved)="resolved($event)" [siteKey]="captchaKey"></re-captcha>
                    </div>
                    <div class="captcha mobile-only" style="transform:scale(0.8);transform-origin:0 0">
                        <re-captcha (resolved)="resolved($event)" [siteKey]="captchaKey"></re-captcha>
                    </div>

                    <div class="feedback-button">
                        <app-button type="submit" [disableButton]="form.invalid"
                        [variation]="form.invalid ? 'button--disabled' : ''" class="form__button"
                        text="Send"></app-button>
                    </div>
                </ng-template>
                <p *ngIf="hasSubmissionError" class="form__sub-copy form__sub-copy--error">
                    An error has occurred while submitting your feedback. Please try again.
                </p>
            </div>
        </form>
    </div>
</div>
<app-bottom-navigation 
    *ngIf="formSubmitted"
        backText="Start Screening"
        backRoute="screening-tool-landing"
        backTab="start-screening"
        continueText="FAQs" 
        continueRoute="faqs">
</app-bottom-navigation>
<ng-template #thankYou>
    <div class="section">
        <h1 class="title">Thank you</h1>
        <h2 class="subtitle">Your feedback has been sent</h2>
    </div>
</ng-template>